import { render } from "./a-entrust.vue?vue&type=template&id=50cc214e&scoped=true"
import script from "./a-entrust.vue?vue&type=script&lang=js"
export * from "./a-entrust.vue?vue&type=script&lang=js"

import "./a-entrust.vue?vue&type=style&index=0&id=50cc214e&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cc214e"]])

export default __exports__